

import { Layout, Button, Row, Col } from "antd-v4";
import { RiMenuFill } from "react-icons/ri";

import HeaderUser from "./HeaderUser";
import MenuLogo from "../menu/logo";
import MenuHorizontal from "../menu/item/MenuHorizontal";
import MenuMobile from "../menu/mobile";
import HeaderLanguages from "./HeaderLanguages";

import { useCustomise } from "../../../context/customiseContext";

const { Header } = Layout;

export default function HeaderHorizontal(props) {
  const { visible, setVisible } = props;

  const { navigationBg, navigationFull } = useCustomise();

  // Header Class — entierement derive des deux props, donc calcule au rendu :
  // la version en state + effet imposait un second rendu du header a chaque
  // changement de navigation.
  const headerClass = navigationFull ? " hp-header-full" : navigationBg ? " hp-header-bg" : "";

  // Mobile Sidebar
  const onClose = () => {
    setVisible(false);
  };

  // Mobile Sidebar
  const showDrawer = () => {
    setVisible(true);
  };

  // Children
  const headerChildren = () => {
    return (
      <Row
        className="hp-w-100 hp-position-relative"
        align="middle"
        justify="space-between"
      >
        <Col>
          <MenuLogo />

          <Col className="hp-mobile-sidebar-button">
            <Button
              className="hp-mobile-sidebar-button"
              type="text"
              onClick={showDrawer}
              icon={
                <RiMenuFill
                  size={24}
                  className="remix-icon hp-text-color-black-80"
                />
              }
            />
          </Col>
        </Col>

        <Col flex="1 0 0" className="hp-mx-24">
          <MenuHorizontal />
        </Col>

        <Col>
          <Row align="middle">
            <HeaderLanguages />
            <HeaderUser />
          </Row>
        </Col>
      </Row>
    )
  }

  return (
    <Header
      className={'hp-header-horizontal' + headerClass}
    >
      <Row justify="center" className="hp-w-100">
        <Col span={24}>
          {headerChildren()}
        </Col>
      </Row>

      <MenuMobile onClose={onClose} visible={visible} />
    </Header>
  );
}
